//@flow
import env from '../../../environment';
import {
  postCreator,
  getCreator,
  putCreator,
  deleteCreator,
} from '../../../http';

export const endpoints = Object.freeze({
  CREATE_QUICK_REPLY: `${env.baseApiUrl}/im/admin/crm-messaging/quick-reply`,
  GET_QUICK_REPLIES: `${env.baseApiUrl}/im/admin/crm-messaging/quick-reply`,
  GET_QUICK_REPLY: `${env.baseApiUrl}/im/admin/crm-messaging/quick-reply/:quickReplyId`,
  EDIT_QUICK_REPLY: `${env.baseApiUrl}/im/admin/crm-messaging/quick-reply/:quickReplyId`,
  DELETE_QUICK_REPLY: `${env.baseApiUrl}/im/admin/crm-messaging/quick-reply/:quickReplyId`,
});

export const createQuickReplyEndpoint = postCreator(
  endpoints.CREATE_QUICK_REPLY
);
export const editQuickReplyEndpoint = putCreator(endpoints.EDIT_QUICK_REPLY);
export const getQuickRepliesEndpoint = getCreator(endpoints.GET_QUICK_REPLIES);
export const deleteQuickReplyEndpoint = deleteCreator(
  endpoints.DELETE_QUICK_REPLY
);
export const getQuickReplyEndpoint = getCreator(endpoints.GET_QUICK_REPLY);
